import React, { useState } from "react";
import { Box } from "@mui/material";

export default function ScratchCardCover({ image }) {
  const [failed, setFailed] = useState(false);
  const custom = !failed ? image : null;
  return (
    <Box sx={{ position: "relative", width: "100%", height: "100%", overflow: "hidden", borderRadius: "inherit" }}>
      <Box component="img" src={custom || "/scratch-card-cover.png"} alt="Scratch card"
        loading="lazy" onError={() => setFailed(true)}
        sx={{ display: "block", width: "100%", height: "100%", objectFit: "cover" }} />
      {!custom && <Box component="img" src="/scratch-card-icons-overlay.svg" alt="" aria-hidden="true"
        sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none" }} />}
    </Box>
  );
}
